



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Slide } from 'vue-burger-menu'
@Component({components: {Slide}})
export default class NavBarComp extends Vue {
    @Prop() navItems ?: Array<object>;
    @Prop() socialItems ?: Array<object>;
    @Prop() footerText?: string;
    @Prop() footerUrl?: string;
    @Prop() isRTL?: Boolean;
    @Prop() theme?: string;
    public direction : string = "right";

    private jsonData: CatalogInfo = catalogInfo;
    private overlay =  this.$refs['overlay'];

    private toggleOverLay(){

        //JQuery Needed for Fadein
        var overLay = $(".over-lay");
        var isInvisibile = overLay.css("opacity") == "0";

        overLay.css("opacity", isInvisibile ? 0.5 : 0)
            .fadeIn(500)
                        .delay(isInvisibile ? 0 : 500)
                        .promise()
                        .done(function() {
                            overLay.width(isInvisibile ? "100%" : 0);
                        });
    }

    public get floatDirection():string{
        return this.jsonData.isRTL ? "float-left" : "float-right";
    }

    public get rtlClass():string{
        return this.jsonData.isRTL ? "navbar-rtl" : "";
    }

    public get linksColor():string{
        return this.theme == "dark" ? "white-text" : "dark-text";
    }

    private mounted(){

    }

    private getLogo(rtl: boolean) {
        const image = require.context('../assets/', false, /\.png$/);
        return rtl ? image('./logo-rtl.png') : image('./DarkLogo.png');
    }

}

